import {useQuery} from '@tanstack/react-query';
import {User} from '@common/types/user';

type UserHook = {
  isLoading: boolean;
  error: Error | null;
  data: User | undefined;
};

type Props = {
  apiPath: string | object;
  endPoints: (apiPath: string | object) => Record<string, string>;
  endpoint?: string;
};

const DEFAULT_ENDPOINT = 'tmt/user'; // if using new profile service

const useUser = ({
  apiPath,
  endPoints,
  endpoint = DEFAULT_ENDPOINT
}: Props): UserHook => {
  const userEndpoint = endPoints(apiPath)[endpoint];
  const {isLoading, error, data} = useQuery<User, Error | null>({
    queryKey: ['user'],
    queryFn: () => fetch(userEndpoint).then(res => res.json())
  });
  return {isLoading, error, data};
};

export default useUser;
